import { getDefaultMeta, sendGameTransactionEvent } from './common';
import { v4 as uuidv4 } from 'uuid';
import { sendGTMEvent } from './gtm-helper';

const sendPurchaseItem = ({
  offerData,
  currentUser,
  count,
  itemId,
  itemName,
  transactionId,
}) => {
  sendGameTransactionEvent({
    ...getDefaultMeta(),
    trans_type: 'web_currency_spend',
    trans_desc: 'earn_item',
    context: offerData.OffersID,
    reference_id: 'web_coin_shop',
    event_source: 'web_portal',
    sys_platform: 'web',
    transaction_id: transactionId,
    sys_user_id: currentUser?.userId ?? null,
    reference_subtype_3: null,
    transaction_type: 'earn',
    currentUser: currentUser ?? null,
    item_id: itemId,
    item_name: itemName,
    quantity: count ?? 1,
    item_balance: null,
  });
};
export const purchaseWebCoinAnalytics = ({
  currentUser,
  offerData,
  itemBalance,
  count,
}) => {
  const transactionId = uuidv4();
  sendGameTransactionEvent({
    ...getDefaultMeta(),
    trans_type: 'web_currency_spend',
    trans_desc: 'buy_item',
    context: offerData.OffersID,
    reference_id: 'web_coin_shop',
    event_source: 'web_portal',
    sys_platform: 'web',
    transaction_id: transactionId,
    sys_user_id: currentUser?.userId ?? null,
    reference_subtype_3: null,
    transaction_type: 'spend',
    currentUser: currentUser ?? null,
    item_id: 'web_currency_web_coin',
    item_name: 'web_coin',
    quantity: -Number(offerData.AlternativeCostAmount),
    item_balance: itemBalance,
  });
  if (offerData.offerItems.length) {
    offerData.offerItems.forEach((item) => {
      sendPurchaseItem({
        offerData,
        currentUser,
        count: item.quantity,
        itemId: item.itemID,
        itemName: item.itemName,
        transactionId,
      });
    });
  } else {
    sendPurchaseItem({
      offerData,
      currentUser,
      count,
      itemId: offerData.OffersID,
      itemName: offerData.title,
      transactionId,
    });
  }
};

export const sendSectionViewedEvent = (sectionId: string) => {
  sendGTMEvent({
    category: 'Web Coin Shop',
    event: `web_coin_shop_section_viewed`,
    action: `web-coin-shop/${sectionId}/viewed`,
  });
};
